import React, { useContext, useMemo, useState, useEffect, useRef } from 'react'
import AddAlert from '@material-ui/icons/AddAlert'
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded'
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded'
import Snackbar from '../../sharedComponents/Snackbar/Snackbar'
import linkCards from 'src/constants/linkCards'
import { Context } from '../../../context/Contex'
import { setSessionId, getUnidad } from '../../../utils/Common'
import './BusinessUnitHome.scss'

const BusinessUnitCard = ({
  id,
  unidad,
  selected,
  onSelect,
}) => {
  const imageSrc = linkCards?.[id]?.link

  return (
    <button
      type="button"
      className={`bu-card${selected ? ' bu-card--selected' : ''}`}
      onClick={() => onSelect(id, unidad)}
      aria-pressed={selected}
    >
      <div className="bu-card__media">
        {imageSrc ? (
          <img src={imageSrc} alt="" className="bu-card__img" />
        ) : (
          <div className="bu-card__img bu-card__img--empty" />
        )}
        <div className="bu-card__shade" />
      </div>

      <div className="bu-card__body">
        <span className="bu-card__name">{unidad}</span>
        <span className="bu-card__cta">
          {selected ? (
            <>
              <CheckCircleRoundedIcon style={{ fontSize: 18 }} />
              Activa
            </>
          ) : (
            <>
              Entrar
              <ArrowForwardRoundedIcon style={{ fontSize: 18 }} />
            </>
          )}
        </span>
      </div>

      {selected && (
        <span className="bu-card__badge" aria-hidden>
          <CheckCircleRoundedIcon style={{ fontSize: 22 }} />
        </span>
      )}
    </button>
  )
}

const BusinessUnitList = ({ data }) => {
  const { title, setTitle, nameId } = useContext(Context)
  const [selectedId, setSelectedId] = useState(() => getUnidad())
  const [toastOpen, setToastOpen] = useState(false)
  const toastTimer = useRef(null)

  const units = useMemo(() => {
    if (!data?.data || !Array.isArray(data.data)) return []
    return data.data
  }, [data])

  useEffect(() => {
    return () => {
      if (toastTimer.current) clearTimeout(toastTimer.current)
    }
  }, [])

  const handleSelect = (id, unidad) => {
    setSessionId(id)
    setTitle(unidad)
    setSelectedId(String(id))
    setToastOpen(true)
    if (toastTimer.current) clearTimeout(toastTimer.current)
    toastTimer.current = setTimeout(() => setToastOpen(false), 2200)
  }

  const firstName = nameId?.nombre
    ? String(nameId.nombre).split(' ')[0]
    : null

  if (!data) return null

  return (
    <div className="bu-home">
      <div className="bu-home__inner">
        <Snackbar
          place="tr"
          color="warning"
          icon={AddAlert}
          message="Unidad de negocio actualizada..."
          open={toastOpen}
        />

        <header className="bu-home__header">
          <p className="bu-home__eyebrow">
            {firstName ? `Hola, ${firstName}` : 'Lucía'}
          </p>
          <p className="bu-home__subtitle">
            {title
              ? `Activa : ${title}.`
              : 'Selecciona una unidad de negocio.'}
          </p>
        </header>

        {units.length > 0 ? (
          <div className="bu-home__grid">
            {units.map((unit) => (
              <BusinessUnitCard
                key={unit.id}
                id={unit.id}
                unidad={unit.unidad}
                selected={String(selectedId) === String(unit.id)}
                onSelect={handleSelect}
              />
            ))}
          </div>
        ) : (
          <div className="bu-home__empty">
            <p>No hay unidades disponibles por ahora.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default BusinessUnitList
